/* FC Wishlist — works on every product card, header, bottom nav and the wishlist page.
   Uses the same localStorage key as the theme's built-in wishlist (m-wishlist-products). */
(function () {
  if (window.FCWishlist) return;

  var KEY = 'm-wishlist-products';
  var ACTIVE = 'is-active';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(list) ? list.filter(Boolean) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(Array.from(new Set(list)))); } catch (e) {}
  }
  var items = read();

  function has(h) { return items.indexOf(h) !== -1; }

  function root() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  /* ---------- UI sync ---------- */
  function syncButton(btn) {
    var on = has(btn.getAttribute('data-handle'));
    btn.classList.toggle(ACTIVE, on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = on ? 'إزالة من المفضلة' : 'إضافة إلى المفضلة';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
  }
  function syncCounts() {
    var n = items.length;
    document.querySelectorAll('[data-fc-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n < 1;
    });
    document.querySelectorAll('[data-fc-wish-link]').forEach(function (el) {
      el.classList.toggle('is-wish-active', n > 0);
    });
    document.body && document.body.classList.toggle('wishlist-has-item', n > 0);
  }
  function syncAll(scope) {
    (scope || document).querySelectorAll('[data-fc-wish]').forEach(syncButton);
    syncCounts();
  }

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fc-wish-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 1800);
  }

  /* ---------- Mutations ---------- */
  function set(handle, on, silent) {
    if (!handle) return;
    var i = items.indexOf(handle);
    if (on && i === -1) items.push(handle);
    if (!on && i !== -1) items.splice(i, 1);
    write(items);
    syncAll();
    if (!silent) toast(on ? 'تمت الإضافة إلى المفضلة ❤️' : 'تمت الإزالة من المفضلة');
    document.dispatchEvent(new CustomEvent('fc:wishlist-change', { detail: { handle: handle, active: on, items: items.slice() } }));
  }
  function toggle(handle) { set(handle, !has(handle)); }

  /* ---------- Click handling ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fc-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var h = btn.getAttribute('data-handle');
    toggle(h);
    if (has(h)) {
      btn.classList.add('is-pop');
      setTimeout(function () { btn.classList.remove('is-pop'); }, 450);
    }
  }, true);

  /* ---------- Auto-inject on any .fc-product-card without a heart ---------- */
  function handleFromCard(card) {
    if (card.dataset && card.dataset.handle) return card.dataset.handle;
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function inject(scope) {
    (scope || document).querySelectorAll('.fc-product-card').forEach(function (card) {
      if (card.querySelector('[data-fc-wish]')) return;
      var h = handleFromCard(card);
      if (!h) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fc-wish-btn';
      b.setAttribute('data-fc-wish', '');
      b.setAttribute('data-handle', h);
      b.innerHTML = '<svg class="fc-wish-btn__icon fc-wish-btn__icon--off" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><svg class="fc-wish-btn__icon fc-wish-btn__icon--on" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      card.appendChild(b);
      syncButton(b);
    });
  }

  /* ---------- Wishlist page ---------- */
  function initPage() {
    var page = document.querySelector('[data-fc-wishlist-page]');
    if (!page) return;
    var grid = page.querySelector('[data-fc-wl-grid]');
    var loading = page.querySelector('[data-fc-wl-loading]');
    var empty = page.querySelector('[data-fc-wl-empty]');
    var head = page.querySelector('[data-fc-wl-head]');
    var total = page.querySelector('[data-fc-wl-total]');
    var clearBtn = page.querySelector('[data-fc-wl-clear]');

    function refreshState() {
      var n = grid.children.length;
      empty.hidden = n > 0;
      head.hidden = n === 0;
      grid.hidden = n === 0;
      if (total) total.textContent = n + (n === 1 ? ' منتج' : ' منتجات');
    }

    function load(handle) {
      return fetch(root() + 'products/' + encodeURIComponent(handle) + '?view=fc-wishlist-card', { credentials: 'same-origin' })
        .then(function (r) {
          if (r.status === 404) return { gone: true };
          if (!r.ok) throw new Error('http ' + r.status);
          return r.text().then(function (t) { return { html: t }; });
        })
        .catch(function () { return { error: true }; });
    }

    var list = items.slice();
    if (!list.length) { loading.hidden = true; refreshState(); }
    Promise.all(list.map(load)).then(function (res) {
      loading.hidden = true;
      res.forEach(function (r, i) {
        if (r.gone) { items = items.filter(function (h) { return h !== list[i]; }); return; }
        if (!r.html || r.html.indexOf('fc-wl-card') === -1) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = r.html.trim();
        var card = tmp.querySelector('.fc-wl-card');
        if (card) grid.appendChild(card);
      });
      write(items);
      syncAll(page);
      refreshState();
    });

    document.addEventListener('fc:wishlist-change', function (e) {
      if (!e.detail.active) {
        var c = grid.querySelector('.fc-wl-card[data-handle="' + (window.CSS && CSS.escape ? CSS.escape(e.detail.handle) : e.detail.handle) + '"]');
        if (c) c.remove();
        refreshState();
      }
    });

    if (clearBtn) clearBtn.addEventListener('click', function () {
      items = [];
      write(items);
      grid.innerHTML = '';
      syncAll();
      refreshState();
    });

    page.addEventListener('click', function (e) {
      var add = e.target.closest('[data-fc-wl-add]');
      if (!add) return;
      e.preventDefault();
      add.classList.add('is-loading');
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(add.getAttribute('data-variant-id')), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          toast('تمت الإضافة إلى السلة 🛒');
        })
        .catch(function () { toast('تعذّرت الإضافة، حاول مرة أخرى'); })
        .then(function () { add.classList.remove('is-loading'); });
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    inject();
    syncAll();
    initPage();
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; inject(); syncAll(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { items = read(); syncAll(); }
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { items = read(); syncAll(); }
  });

  window.FCWishlist = { has: has, toggle: toggle, set: set, all: function () { return items.slice(); } };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
